import { type FC, type PropsWithChildren, Suspense } from 'react';

import { Container, type ContainerProps, Flex } from '@chakra-ui/react';

import { Viewport } from '@/components';

import { LegalNavBar } from './LegalNavBar';

const PageContainer = ({ children, maxW, ...rest }: ContainerProps) => {
  return (
    <Container
      display="flex"
      flexDirection="column"
      flex="1"
      w="full"
      maxW={maxW}
      {...rest}
    >
      {children}
    </Container>
  );
};

export const LegalLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Suspense>
      <Viewport bgGradient="white">
        <LegalNavBar display="block" />
        <Flex flex="1" direction="column" pt={4}>
          <PageContainer maxW="container.xl">{children}</PageContainer>
        </Flex>
      </Viewport>
    </Suspense>
  );
};
